export default __webpack_public_path__ + "static/media/Delete.f62d6cda.svg";